<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="8"
        xl="6"
        offset-md="2"
        offset-xl="3"
      >
        <v-toolbar-title>
          {{ $t('substitute.title') }}
        </v-toolbar-title>
        <br>

        <s-date-picker
          v-model="date"
          outlined
          background-color="white"
          :append-icon="mdiCalendar"
          hide-details
          :label="$t('Text.Date')"
        />

        <v-switch
          v-model="onlyShowAbsent"
          :label="$t('substitute.onlyShowAbsentChief')"
        />

        <v-card
          v-for="(info, index) in subsInfos2Show"
          :key="index"
          class="mb-3"
        >
          <v-card-title class="text-h6">
            {{ $chPtObjData('chinSubunitName', info) }} ({{ info.subunitAbbr }}) {{ $chPtObjData('chinTitleForDisplay', info) }}
          </v-card-title>
          <v-card-text>
            <div class="mt-4 text-subtitle-1 black--text">
              {{ info.chinStaffName }} {{ info.portStaffName }} ({{ info.staffNickName }})
              <v-chip
                v-if="info.vinculumTypeId == 16"
                color="blue"
                outlined
                small
                class="mr-1"
              >
                {{ $t('substitute.substitute') }}
              </v-chip>
              <v-chip
                v-if="info.isRefDateOverlapAbsentDateRange"
                color="red"
                outlined
                dark
                small
                class="mr-1"
              >
                {{ $t('substitute.absence') }}
              </v-chip>
              <v-chip
                v-if="isSubstituting(info.staffCode)"
                color="deep-orange"
                outlined
                dark
                small
              >
                {{ substituteTitle(info.staffCode) }}
              </v-chip>
            </div>
            <div>{{ info.companyTel }}</div>
            <div><a :href="'mailto:' + info.email">{{ info.email }}</a></div>
          </v-card-text>
          <v-card-text v-if="info.subStaffCode">
            <div class="mt-4 text-subtitle-1 black--text">
              {{ info.chinSubStaffName }} {{ info.portSubStaffName }} ({{ info.subStaffNickName }})
              <v-chip
                color="blue"
                outlined
                small
              >
                {{ $t('substitute.officialTempSubstitute') }}
              </v-chip>
            </div>
            <div>{{ info.subCompanyTel }}</div>
            <div><a :href="'mailto:' + info.subEmail">{{ info.subEmail }}</a></div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              depressed
              @click="saveInfo2Vuex(info)"
            >
              {{ $t('Text.Detail') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import SDatePicker from '@/components/SDatePicker'
import { dateToYyyyMmDd } from '@/utils/datetimeUtil'
import g2eApi from '../../api/hr/g2e'
import { substituteModule } from '../../store/moduleName'
import substituteVuex from '../../store/modules/substitute/substitute'
import store from '../../store'
import { mapState } from 'vuex'
import { mdiCalendar } from '@mdi/js'

if (!store.state[substituteModule]) store.registerModule(substituteModule, substituteVuex)

export default {
  components: {
    SDatePicker
  },
  data: function () {
    return {
      mdiCalendar: mdiCalendar,
      date: null,
      onlyShowAbsent: true,
      substInfos: []
    }
  },
  computed: {
    ...mapState({
      selectedDate: state => state[substituteModule].selectedDate
    }),
    subsInfos2Show: function () {
      if (this.onlyShowAbsent) {
        return this.substInfos.filter(info => info.isRefDateOverlapAbsentDateRange)
      } else {
        return this.substInfos
      }
    }
  },
  watch: {
    date: function (newDate, oldDate) {
      if (newDate !== oldDate) {
        this.$store.commit(substituteModule + '/updateSelectedDate', this.date)
        g2eApi.findStaffOfficialSubstInfoByDate(this.selectedDate, resp => {
          if (resp.status === 201 || resp.status === 200) {
            this.substInfos = resp.data
          }
        })
      }
    }
  },
  created () {
    if (!this.selectedDate) {
      this.$store.commit(substituteModule + '/updateSelectedDate', dateToYyyyMmDd(new Date()))
    }
    this.date = this.selectedDate
  },
  methods: {
    isSubstituting: function (staffCode) {
      let found = this.substInfos.find(obj => obj.subStaffCode === staffCode)
      if (found) {
        return true
      } else {
        return false
      }
    },
    substituteTitle: function (staffCode) {
      let found = this.substInfos.find(obj => obj.subStaffCode === staffCode)
      if (found) {
        return this.$t('substitute.currSub', [this.$chPtObjData('chinSubunitName', found), this.$chPtObjData('chinTitleForDisplay', found)])
      }
    },
    saveInfo2Vuex: function (info) {
      this.$store.commit(substituteModule + '/updateCurrSubInfo', info)
      this.$router.push({ name: 'StaffEntityOfficialDetail', params: { substituteTitle: this.substituteTitle(info.staffCode) } })
    }
  }
}
</script>
